export default "/assets/chef-hat.svg";